import {GenericIconName, Icon} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';

export const CouponHintIcon: FC<{'data-testid'?: string}> = ({
  'data-testid': dataTestId,
}) => (
  <CouponIcon
    data-testid={dataTestId}
    asset={GenericIconName.couponHintCloud}
    size="S"
  />
);

const CouponIcon = styled(Icon)`
  position: absolute;
  top: 0;
  left: 0;
`;
